import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

export default function ForbiddenPage() {
  const { lang } = useLanguage();

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#FAF7F2] px-4 py-20">
      <SEO title={lang === 'da' ? '403 Adgang nægtet' : '403 Access Denied'} />
      <div className="text-center max-w-md space-y-6">
        <span className="font-serif-display text-7xl font-bold text-[#A86D51]">403</span>
        <h1 className="font-serif-display text-3xl font-bold text-[#2C2825]">
          {lang === 'da' ? 'Adgang nægtet' : 'Access Denied'}
        </h1>
        <p className="text-sm text-[#6E6760] leading-relaxed">
          {lang === 'da'
            ? 'Du har ikke tilladelse til at tilgå denne ressource.'
            : 'You do not have permission to access this resource.'}
        </p>
        <div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2E3191] text-white text-sm font-semibold hover:bg-[#1E2063] transition-all"
          >
            <i className="fa-solid fa-house text-xs" />
            {lang === 'da' ? 'Gå til forsiden' : 'Return Home'}
          </Link>
        </div>
      </div>
    </div>
  );
}
